import { render, staticRenderFns } from "./Stationtap.vue?vue&type=template&id=96a35730&"
import script from "./Stationtap.vue?vue&type=script&lang=js&"
export * from "./Stationtap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports